const d =
	'M80-160v-90h86v-490q0-24.75 17.625-42.375T226-800h620v60H226v490h234v90H80Zm479 0q-16.575 0-27.787-13.5Q520-187 520-204v-437q0-16.575 11.213-27.787Q542.425-680 559-680h271.751Q850-680 865-669.5q15 10.5 15 28.5v437.273q0 18.584-14.5 31.155Q851-160 831-160H559Zm21-90h240v-370H580v370Z';

export default d;
